import React from 'react';
import PropTypes from 'prop-types';

import {cn} from 'spa/css';

class FormGroup extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    htmlFor: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]).isRequired,
  };

  render() {
    const {
      label, htmlFor, className, children,
    } = this.props;
    return (
      <div className={cn('form-group', className)}>
        {label && <label htmlFor={htmlFor}>{label}</label>}
        {children}
      </div>
    );
  }
}

export default FormGroup;



// WEBPACK FOOTER //
// ./spa/Components/Form/FormGroup.jsx